import React, { useEffect, useState } from "react";
import { MyBids } from "../../Pages/MyTenderAndBids/MyBids";
import "./MyBidsPage.scss";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.scss";

import { useAuth } from "../Context/AuthContext";
import { getMyBids } from "../Api/GetApi";
import { catchError } from "../utils/catchError";
import { NoDataFound } from "../NoDataFound/NoDataFound";
import { ResponseTenderCard } from "../TenderCard/TenderCardGroup";
import { MyBidShimmer } from "../../Pages/MyBidShimmer/MyBidShimmer";
import { isBidder, isPublisher } from "../../utils/services";

export interface ResponseData {
  In_progress?: Array<any>;
  Submitted?: Array<any>;
  Withdrawn?: Array<any>;
  all_bids?: Array<any>;
}

export const MyBidsPage = () => {
  window.scrollTo(0, 0);
  const [data, setData] = useState<any>();
  // const[submitted,setSubmitted]=useState([])
  // const[withDrawn,setWithDrawn]=useState([])
  const [loading, setLoading] = useState(true);
  const { role } = useAuth();
  const tabsBidder = ["Unsubmitted Notice","EOI Status", "Submitted Notice", "Withdrawn Notice"];
  const tabsPublisher = [
    "Unpublished Notice",
    "Published Notice",
    "Awarded Notice",
  ];

  const FetchMyBids = () => {
    setLoading(true);
    getMyBids()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data.data);
        }
      })
      .catch((err) => {
        catchError(
          err.response.status,
          err.response.data.status.status_message
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  //Reftech logic

  const reFetchMyBids = () => {
    getMyBids()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data.data);
        }
      })
      .catch((err) => {
        catchError(
          err.response.status,
          err.response.data.status.status_message
        );
      });
  };

  useEffect(() => {
    FetchMyBids();
  }, []);

  return (
    <div className="bids-page">
      <div className="container">
        <div className="bids-tabsection">
          <div className="card card-bid">
            <div className="d-flex">
              {isBidder(role) && <p className="bid-title">My Bids</p>}
              {isPublisher(role) && <p className="bid-title">My Tenders</p>}
            </div>
            <Tabs>
              <TabList>
                {isBidder(role) &&
                  tabsBidder.map((item: string, id: number) => {
                    return (
                      <React.Fragment key={id}>
                        <Tab>{item}</Tab>
                      </React.Fragment>
                    );
                  })}
                {isPublisher(role) &&
                  tabsPublisher.map((item: string, index: number) => {
                    return (
                      <React.Fragment key={index}>
                        <Tab>{item}</Tab>
                      </React.Fragment>
                    );
                  })}
              </TabList>

              <div className="outer-border">
                {loading ? (
                  <>
                    <MyBidShimmer />
                  </>
                ) : (
                  <>
                    {data ? (
                      <>
                        {Object.keys(data).map((key, id) => {
                          return (
                            <>
                              <TabPanel key={id}>
                                {data[key].length > 0 ? (
                                  data[key].map(
                                    (item: ResponseTenderCard, id: number) => {
                                      return (
                                        <div className="card-bottom" key={id}>
                                          <MyBids
                                            key={item.id}
                                            type={key}
                                            reFetchMyBids={reFetchMyBids}
                                            tenderNoticeData={item}
                                          />
                                        </div>
                                      );
                                    }
                                  )
                                ) : (
                                  <NoDataFound
                                    text1={`No ${
                                      isBidder(role) ? "Bids" : "Tenders"
                                    }`}
                                    img={require("../../images/nodata.png")}
                                  />
                                )}
                              </TabPanel>
                            </>
                          );
                        })}
                      </>
                    ) : (
                      <NoDataFound
                        text1="No Bids"
                        text2="You can see all your bids here"
                        img={require("../../images/nodata.png")}
                      />
                    )}
                  </>
                )}
              </div>
            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
};

